export default __webpack_public_path__ + "static/media/logo.42146e92.png";